import React, { useState } from 'react';
import StakeholderCard from '../components/StakeholderCard';
import NZMap from '../components/NZMap';
import { stakeholders } from '../utils/mockData';
import { nzRegionData } from '../utils/nzRegionData';
import { colors } from '../utils/colors';
const StakeholdersGeography = () => {
  const [hoveredRegion, setHoveredRegion] = useState<any>(null);
  const [selectedRegion, setSelectedRegion] = useState<string | null>(null);
  // Function to handle region hover
  const handleRegionHover = (region: any) => {
    setHoveredRegion(region);
  };
  // Get top regions by submission count for the stats section
  const topRegions = [...nzRegionData].sort((a, b) => b.count - a.count).slice(0, 4);
  return <div data-id="element-249">
      <div className="mb-6" data-id="element-250">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-251">
          Stakeholders & Geography
        </h1>
        <p className="mt-1 text-sm text-gray-600" data-id="element-252">
          Who is participating and where they are located
        </p>
      </div>
      <div className="bg-white rounded-lg shadow p-5 mb-6" data-id="element-253">
        <h2 className="text-lg font-medium text-gray-900 mb-4" data-id="element-254">
          Geographic Distribution
        </h2>
        <div className="aspect-w-16 aspect-h-9 bg-gray-50 rounded-lg flex items-center justify-center relative mb-4" data-id="element-255">
          {/* Map visualization */}
          <NZMap regionData={nzRegionData} onRegionHover={handleRegionHover} selectedRegion={selectedRegion} data-id="element-256" />
          {/* Hover information */}
          {hoveredRegion && <div className="absolute top-4 right-4 bg-white p-3 rounded-md shadow-md" data-id="element-257">
              <h3 className="font-medium text-gray-900" data-id="element-258">
                {hoveredRegion.name}
              </h3>
              <p className="text-sm text-gray-600" data-id="element-259">
                {hoveredRegion.count} submissions
              </p>
            </div>}
          {/* Legend */}
          <div className="absolute bottom-4 left-4 bg-white p-3 rounded-md shadow-md" data-id="element-260">
            <h4 className="text-xs font-medium text-gray-700 mb-2" data-id="element-261">
              Submissions
            </h4>
            <div className="flex flex-col space-y-1" data-id="element-262">
              <div className="flex items-center" data-id="element-263">
                <div className="w-4 h-4 mr-2" style={{
                backgroundColor: colors.primary.dark
              }} data-id="element-264"></div>
                <span className="text-xs" data-id="element-265">250+</span>
              </div>
              <div className="flex items-center" data-id="element-266">
                <div className="w-4 h-4 mr-2" style={{
                backgroundColor: colors.primary.medium
              }} data-id="element-267"></div>
                <span className="text-xs" data-id="element-268">200-249</span>
              </div>
              <div className="flex items-center" data-id="element-269">
                <div className="w-4 h-4 mr-2" style={{
                backgroundColor: colors.primary.light
              }} data-id="element-270"></div>
                <span className="text-xs" data-id="element-271">150-199</span>
              </div>
              <div className="flex items-center" data-id="element-272">
                <div className="w-4 h-4 mr-2" style={{
                backgroundColor: colors.ui.lightTeal
              }} data-id="element-273"></div>
                <span className="text-xs" data-id="element-274">100-149</span>
              </div>
              <div className="flex items-center" data-id="element-275">
                <div className="w-4 h-4 mr-2" style={{
                backgroundColor: colors.ui.veryLightTeal
              }} data-id="element-276"></div>
                <span className="text-xs" data-id="element-277">&lt;100</span>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-4 grid grid-cols-2 sm:grid-cols-4 gap-4" data-id="element-278">
          {topRegions.map(region => <div key={region.id} className="text-center cursor-pointer" onClick={() => setSelectedRegion(region.id === selectedRegion ? null : region.id)} data-id="element-279">
              <div className={`text-2xl font-bold`} style={{
            color: region.id === selectedRegion ? colors.primary.medium : colors.primary.dark
          }} data-id="element-280">
                {region.name}
              </div>
              <div className="text-sm text-gray-500" data-id="element-281">
                {region.count} submissions
              </div>
            </div>)}
        </div>
      </div>
      <div className="mb-8" data-id="element-282">
        <h2 className="text-lg font-medium text-gray-900 mb-4" data-id="element-283">
          Stakeholder Breakdown
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4" data-id="element-284">
          {stakeholders.map((stakeholder, index) => <StakeholderCard key={index} type={stakeholder.type} count={stakeholder.count} percentage={stakeholder.percentage} color={stakeholder.color} data-id="element-285" />)}
        </div>
      </div>
      <div className="bg-white rounded-lg shadow p-5" data-id="element-286">
        <h2 className="text-lg font-medium text-gray-900 mb-4" data-id="element-287">
          Treaty Partnership Summary
        </h2>
        <div className="space-y-3" data-id="element-288">
          <div className="p-3 rounded-lg" style={{
          backgroundColor: colors.ui.veryLightTeal
        }} data-id="element-289">
            <p className="text-sm font-medium" style={{
            color: colors.primary.dark
          }} data-id="element-290">
              Co-governance arrangements
            </p>
            <p className="text-xs text-gray-600 mt-1" data-id="element-291">
              Raised in 76% of iwi/hapū submissions
            </p>
          </div>
          <div className="p-3 rounded-lg" style={{
          backgroundColor: colors.ui.veryLightTeal
        }} data-id="element-292">
            <p className="text-sm font-medium" style={{
            color: colors.primary.dark
          }} data-id="element-293">
              Protection of cultural values
            </p>
            <p className="text-xs text-gray-600 mt-1" data-id="element-294">
              Raised in 64% of iwi/hapū submissions
            </p>
          </div>
          <div className="p-3 rounded-lg" style={{
          backgroundColor: colors.ui.veryLightTeal
        }} data-id="element-295">
            <p className="text-sm font-medium" style={{
            color: colors.primary.dark
          }} data-id="element-296">
              Mātauranga Māori integration
            </p>
            <p className="text-xs text-gray-600 mt-1" data-id="element-297">
              Raised in 58% of iwi/hapū submissions
            </p>
          </div>
        </div>
      </div>
    </div>;
};
export default StakeholdersGeography;